// src/lib/synthese-marge-partielle.js — micro-lot admin (décision Dimitri
// 2026-08-01), panneau Revenu FBZ de la Synthèse du mois (Gestion > Données).
//
// PROBLÈME : en tout début de mois, presque aucun revenu n'est encore saisi
// alors que les charges fixes sont déjà comptées → la marge nette s'affiche en
// ROUGE vif, comme une alerte, alors que c'est juste un mois incomplet.
//
// RÈGLE (helper PUR, testé) : la marge nette NÉGATIVE s'affiche en GRIS avec
// une mention « Chiffres partiels… » UNIQUEMENT si le mois affiché est le mois
// calendaire EN COURS et que le jour du mois est < 10. Tous les autres cas
// (mois passés, mois courant à partir du 10, marge positive) gardent le
// comportement actuel — l'affichage seul change, jamais le calcul de la marge.

/**
 * Le mois affiché est-il le mois calendaire en cours, avant le 10 ?
 * @param {number} y — année affichée (ex. 2026)
 * @param {number} m — mois affiché 1-12 (convention MonthNav de l'app)
 * @param {Date} [now=new Date()] — injectable pour les tests (déterminisme)
 * @returns {boolean}
 */
export function isEarlyCurrentMonth(y, m, now = new Date()) {
  return (
    y === now.getFullYear() && m === now.getMonth() + 1 && now.getDate() < 10
  );
}

/**
 * La marge nette doit-elle être ATTÉNUÉE (gris + mention « chiffres
 * partiels ») au lieu du rouge d'alerte ?
 * Vrai UNIQUEMENT si marge STRICTEMENT négative ∧ mois courant ∧ jour < 10.
 * @param {number} marge — marge nette du mois affiché (euros)
 * @param {number} y — année affichée
 * @param {number} m — mois affiché 1-12
 * @param {Date} [now=new Date()] — injectable pour les tests
 * @returns {boolean}
 */
export function margeNetteEstAttenuee(marge, y, m, now = new Date()) {
  return marge < 0 && isEarlyCurrentMonth(y, m, now);
}
